import { selector } from "recoil";
import { AppProviderAPI } from "../../api";
import { getDesignThumb } from "../../api/appProvider";
import { apiUrl } from "../../constants";
import { arrangeDesignTree } from "../../utils";
import { apiKeyState, userDetailState } from "./atoms";
export const fetchInterfaceElements = selector({
  key: "fetchInterfaceElements",
  get: async ({ get }) => {
    const apiKey = get(apiKeyState);
    try {
      const interfaceElements = AppProviderAPI.getInterfaceElements({ apiKey });
      return interfaceElements;
    } catch (error) {
      throw error;
    }
  },
});
export const fetchApiKey = selector({
  key: "apikeySelector",
  get: async ({ get }) => {
    const apikey = sessionStorage.getItem("apikey") || localStorage.getItem("apikey" || localStorage.getItem("key"));
    if (apikey && apikey !== "" && apikey !== "null" && apikey !== "undefined") {
      return apikey;
    }
    const { username, password } = get(userDetailState);

    console.log(username, password);
    if (!username || !password) return null;
    try {
      const formdata = new FormData();
      formdata.append("action", "login");
      formdata.append("username", username);
      formdata.append("password", password);
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formdata,
      });
      const data = await response.json();
      sessionStorage.setItem("apikey", data.Key);
      return data.Key;
    } catch (error) {
      throw error;
    }
  },
});

// export const fetchDesignList = selector({
//   key: "designListSelector",
//   get: async ({ get }) => {
//     try {
//       const key = get(fetchApiKey)
//       const designTreeState = await getDesignTree({ key })
//       return designTreeState
//     } catch (error) {
//       throw error
//     }
//   }
// })
export const getDesignTree = async ({ key }) => {
  const formdata = new FormData();
  formdata.append("action", "designlist");
  formdata.append("mode", "struct");
  formdata.append("key", key);
  const response = await fetch(apiUrl, {
    method: "POST",
    body: formdata,
  });
  const tree = await response.json();
  const { designTree, selectedFolder, selectedDesign } = arrangeDesignTree({ tree });
  // const selectedFolder = designTree[0]
  const designWithProps = await getDesignThumb(key, [selectedDesign]);

  return { designTree, selectedFolders: [selectedFolder], selectedDesigns: designWithProps };
};
